export default "__VITE_PUBLIC_ASSET__2ffcf44e__"